export const FORMAT_DATE = 'dd.MM.yyyy';
export const DOCUMENTS_FILE_TYPES = '.pdf';

export const getDisplayTypeSource = () => {
  return [
    { id: 'sup', title: 'sup' },
    { id: 'after', title: 'after' },
  ];
};

export const patchDataMiddleware = (data: any) => {
  const duplicate = { ...data };

  if (duplicate.hasOwnProperty('ratingSymbolID')) {
    duplicate.ratingSymbolID = duplicate.ratingSymbolID || null;
  }
  if (duplicate.hasOwnProperty('publishDate')) {
    duplicate.publishDate = duplicate.publishDate || null;
  }
  if (duplicate.hasOwnProperty('outlookID')) {
    duplicate.outlookID = duplicate.outlookID || null;
  }
  if (duplicate.hasOwnProperty('validDate')) {
    duplicate.validDate = duplicate.validDate || null;
  }
  return duplicate;
};
